export default "__VITE_ASSET__772a1745__"